import { getFormattedDateReverse } from '../../utils/date';
import './tripStrapMobile.css';

import UserIcon from '../../assets/icons/trvto_guest.png';
import LocationIcon from '../../assets/icons/trvto_location.svg';
import CalenderIcon from '../../assets/icons/trvto_calendar.svg';
import Clock from '../../assets/icons/trvto_clock.svg';
import { share, SHARE_LABEL } from '../tripStrap/tripStrapFun/shareFun';
import { ReactComponent as Close } from '../../assets/icons/trvto_close.svg';
import { ReactComponent as Share } from '../../assets/icons/trvto_share.svg';
import Bookings from '../../assets/icons/trvto_bookings.svg';
import DaysIcon from '../../assets/icons/trvto_timer_icon.svg';
import MenuIcon from '../../assets/icons/three-dots.svg';
import { getTotalSeatCount } from '../../utils/getTotalSeatCount';
import { useEffect, useState } from 'react';
import TableContent from './tableContent';
import { getHikedPrice } from '../../utils/getAmountWithTransaction';
import { standardDate } from '../../utils/formatDate';
import { truncateText } from '../../utils/maskFields';

const TripStrapMobile = ({
    key,
    data,
    type,
    handleClick,
    // which buttons this booking gets (pages/myBookings bookingActions) + pickup/meetup change
    actions = {},
    openForChange,
    handleCancelBooking,
    handleRescheduleBooking,
    openRatingModal
}) => {
    const [showBookingInfo, setShowBookingInfo] = useState(false);
    const [showManage, setShowManage] = useState(false);
    const totalSeats = Array.isArray(data?.totalSeats) ? getTotalSeatCount(data?.totalSeats) : data?.totalSeats || 0;
    const bookingData = [
        {
            label: type === 'trip' ? 'Trip Name' : 'Name',
            answer: data.id?.title || 'N/A'
        },
        {
            label: 'Booking Id',
            answer: data?._id || 'N/A'
        },
        ...(type === 'trip'
            ? [
                  {
                      label: 'Start City',
                      answer: data?.startCity
                  },
                  { label: 'Destination', answer: data?.id?.quickView?.where }
              ]
            : []),
        ...(type === 'camp'
            ? [
                  { label: 'Stay', answer: data?.id?.quickView?.duration },
                  { label: 'Check-out', answer: standardDate(data?.endDate) }
              ]
            : []),
        ...(type !== 'trip' && type !== 'camp'
            ? [
                  {
                      label: 'Time Slot',
                      answer: `${data?.timeSlots?.startTime} - ${data?.timeSlots?.endTime}`
                  }
              ]
            : []),
        ...(type === 'gu'
            ? [
                  {
                      label: 'Place',
                      answer: data?.place?.name
                  }
              ]
            : []),
        ...(type === 'camp' ? [] : [{
            label: type === 'trip' ? 'Pickup Location' : 'Meetup Location',
            answer:
                type === 'trip' ? (
                    data?.pickupLocation
                ) : (
                    <a href={data?.meetupLocation?.location}>{data?.meetupLocation?.name}</a>
                )
        }]),
        {
            label: type === 'camp' ? 'Check-in' : 'Trip Date',
            answer: standardDate(data?.startDate)
        },
        ...(!data?.amountPaid?.isReserved && !data?.amountPaid?.isInstallment
            ? [
                  {
                      label: 'Total Amount',
                      answer: `₹${getHikedPrice(data?.amountPaid?.actual)}`
                  },
                  {
                      label: 'Discount',
                      answer: `₹${getHikedPrice(data?.amountPaid?.actual * 0.2)}`
                  },
                  {
                      label: 'Tax',
                      answer: `₹${data?.amountPaid?.tax || 0}`
                  },
                  {
                      label: 'Offer Amount',
                      answer: `₹${data?.amountPaid?.offerAmount || 0}`
                  }
              ]
            : []),
        {
            label: 'Amount Paid',
            answer: (
                <>
                    ₹{data?.amountPaid?.paid}
                    {data.isReserved || data?.amountPaid?.isReserved ? (
                        <div className='leftAmountDiv'>
                            Remaining amount to be paid on the trip Rs.
                            {data?.amountPaid?.balance ??
                                data?.amountPaid?.total - data?.amountPaid.reserve * data.totalSeats}{' '}
                            (including tax)
                        </div>
                    ) : null}
                </>
            )
        },

        {
            label: 'No. of Seats',
            answer: Array.isArray(data?.totalSeats) ? getTotalSeatCount(data?.totalSeats) : data?.totalSeats || 0
        },
        {
            label: 'Organizer Name',
            answer: data.id?.organizerName
        }
    ];
    useEffect(() => {
        const closeManage = () => {
            setShowManage(false);
        };

        window.addEventListener('click', closeManage);

        return () => {
            window.removeEventListener('click', closeManage);
        };
    }, []);

    return (
        <div key={key} className='mobileStrip'>
            <div
                className='mainDivStrap'
                onClick={() => {
                    handleClick(data?.id?._id);
                }}
            >
                {/* IMAGE */}
                <div className='imageContent'>
                    <div className='cardImage'>
                        <img src={data?.id?.cardImages?.[0]} alt='trvto_trip' />
                    </div>
                </div>

                {/* TEXT CONTENT */}
                <div className='textContent'>
                    {/* TITLE */}
                    <div className='textContentTitle'>
                        <div className='tripTitle' style={{ fontSize: '16px' }}>
                            {truncateText(data?.id?.title, 20)}
                        </div>

                        <img
                            className='menuIcon'
                            src={MenuIcon}
                            alt='Menu-Icon'
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowManage((prev) => !prev);
                            }}
                        />
                    </div>

                    {/* TOP INFO */}
                    <div className='infoGrid'>
                        <div className='infoItem'>
                            <img className='bookingIcons' src={LocationIcon} alt='Location' />
                            <span>
                                {/* trips and camps send `where` (a camp's city, state); activities / guides send baseCities */}
                                {type === 'trip' || type === 'camp'
                                    ? data?.id?.quickView?.where
                                    : data?.id?.quickView?.baseCities}
                            </span>
                        </div>

                        <div className='infoItem durationItem'>
                            <img className='bookingIcons' src={Clock} alt='Duration' />
                            <span>{data?.id?.quickView?.duration}</span>
                        </div>

                        <div className='infoItem'>
                            <img className='bookingIcons' src={CalenderIcon} alt='Date' />
                            <span>{getFormattedDateReverse(data?.startDate)}</span>
                        </div>

                        <div className='infoItem'>
                            <img className='bookingIcons' src={UserIcon} alt='User' />
                            <span>{totalSeats}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={data?.status === 'Cancelled' ? 'statusChip cancelledChip' : 'statusChip'}>
                <span className='statusDot'></span>
                <span style={{ fontSize: '12px' }}>{data?.status}</span>
            </div>
            {/* BUTTONS */}
            <div className='buttons'>
                <div
                    onClick={() => {
                        setShowBookingInfo(true);
                    }}
                >
                    View Details
                </div>
                {/* <div
                    className='manageBtn'
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowManage((prev) => !prev);
                    }}
                >
                    Manage
                </div> */}
            </div>
            {showBookingInfo && (
                <div
                    className='ratingModal bookingModal'
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowBookingInfo(false);
                    }}
                >
                    <div className='modalHeader'>
                        Booking Info
                        <Close className='iconSize' />
                    </div>
                    <div className='modalContent'>
                        <TableContent data={bookingData} />
                    </div>
                </div>
            )}
            {showManage && (
                <div className='manageDiv'>
                    <div onClick={(e) => share(e, data?.id?._id, type, data?.id?.title)} className='options'>
                        {' '}
                        <Share className='bookingIcons' />
                        Share {SHARE_LABEL[type] || 'Trip'}
                    </div>
                    {actions.pickup && (
                        <div
                            onClick={(event) => openForChange(event, data, { isTripMoreThanOneDays: true })}
                            className='options'
                        >
                            <img className='bookingIcons' src={LocationIcon} alt='Location-Icon' />
                            Update Pickup Location
                        </div>
                    )}
                    {actions.meetup && (
                        <div onClick={(event) => openForChange(event, data)} className='options'>
                            <img className='bookingIcons' src={LocationIcon} alt='Location-Icon' />
                            Change Meetup Location
                        </div>
                    )}
                    {actions.reschedule && (
                        <div onClick={(e) => handleRescheduleBooking(e, data)} className='options'>
                            {' '}
                            <img className='bookingIcons' src={CalenderIcon} alt='Calender-Icon' />
                            {type === 'camp' ? 'Change Dates' : 'Reschedule'}
                        </div>
                    )}
                    {actions.rate && (
                        <div onClick={(e) => openRatingModal(e, data)} className='options'>
                            <img className='bookingIcons' src={Bookings} alt='Booking-Icon' />
                            Rate Now
                        </div>
                    )}
                    {actions.cancel && (
                        <div
                            onClick={(e) => {
                                handleCancelBooking(e, data);
                            }}
                            className='options cancelOption'
                        >
                            <Close className='bookingIcons' />
                            Cancel
                        </div>
                    )}
                    {actions.bookAgain && (
                        <div
                            className='options bookAgainOption'
                            onClick={(e) => {
                                handleClick(data?.id?._id);
                            }}
                        >
                            <img className='bookingIcons' src={Bookings} alt='Booking-Icon' />
                            Book Again
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default TripStrapMobile;
